import React, { Component } from 'react';
import Link from 'gatsby-link';

class header extends Component {
  render() {
    return (
      <div className="top_head">
        <div className="container">
          <div className="top_logo">
            <a  href="https://www.funnelenvy.com"><img src="https://www.funnelenvy.com/wp-content/uploads/logo.png" /></a>
          </div>
          <div className="top_head_text">
            <p><Link to="/"  >PRO ROI Calculator</Link></p>
          </div>
        </div>
      </div>
    );
  }
}

export default header;



// WEBPACK FOOTER //
// ./src/components/header.js